import { Author, PartnerAuthor } from 'pleinchamp-api-client';
import React, { ComponentProps, FC } from 'react';
import { PlcFlatRectLoader } from '@components/Loaders/PlcFlatRectLoader.component';
import { PlcImg } from '@components/PlcImg/PlcImg.component';
import { Text } from '@components/Text/Text.component';
import { PlcAnchor } from '@layout/components/PlcAnchor/PlcAnchor.component';
import { getSlugLinkProps, urlEnum } from '@utils/url';
import classnames from 'classnames';

import styles from './ContentAuthor.module.scss';

interface Props extends ComponentProps<'div'> {
  author: Author | PartnerAuthor;
  i18nKey?: string;
  i18nOptions?: { [key: string]: string | number };
}

function isAuthor(author: Author | PartnerAuthor): author is Author {
  return Object.prototype.hasOwnProperty.call(author, 'partnerPageSlug');
}

export const ContentAuthor: FC<Props> = ({
  author,
  i18nKey = 'common.published-by',
  i18nOptions = {},
  className,
  ...rest
}) => {
  const { partnerName: name, partnerIcon: icon } = author;
  const slug = isAuthor(author) ? author.partnerPageSlug : undefined;

  const rootClass = classnames(styles['content-author'], className);
  const innerHtml = (
    <div className={rootClass} {...rest}>
      {icon && (
        <PlcImg
          alt={icon.alt}
          loader={<PlcFlatRectLoader fixedWidth height={70} uniqueKey="icon-author" width={70} />}
          plcSrc={{ src: icon.url, type: 'external' }}
        />
      )}
      <Text i18nKey={i18nKey} i18nOptions={{ ...i18nOptions, author: name }} tag="span" variant="h6" />
    </div>
  );

  return slug ? <PlcAnchor linkProps={getSlugLinkProps(urlEnum.partners, slug)}>{innerHtml}</PlcAnchor> : innerHtml;
};
